export enum ParseClasses {
    PATIENTS = 'Students',
    PARENTS = 'Parents',
    BUSINESSES = 'Businesses',
    STUDENTS = 'Students',
    APPOINTMENTS = 'Appointments',
    SERVICES = 'Services',
    LOCATIONS = 'Locations',
    PRACTITIONERS = 'Practitioners',
    UPLOADS = 'Uploads',
    DAILYREPORT = 'DailyReports',
    MEALPLANS = 'MealPlans',
    MEALS = 'Meals',
    GROUPS = 'Groups',
    COMMUNITY_GROUPS = 'CommunityGroups',
    COMMUNITY_MEMBERS = 'CommunityGroupMembers',
    COMMUNITY_REQUESTS = 'CommunityGroupJoinRequests',
    COMMUNITY_INVITATIONS = 'CommunityGroupInvitations',
    COMMUNITY_LOCATIONS = 'CommunityGroupLocations',
    GEOGRAPHIC_AREAS = 'GeographicAreas',
    GOLF_COURSES = 'GolfCourses',
    COMMUNITY_GOLF = 'CommunityGroupGolfProfiles',
    COMMUNITY_GOLF_COURSES = 'CommunityGroupGolfCourses',
    COMMUNITY_CYCLING = 'CommunityGroupCyclingProfiles',
    USER_ACTIVITY_PROFILES = 'UserActivityProfiles',
    USER_GOLF_PROFILES = 'UserGolfProfiles',
    USER_GOLF_COURSES = 'UserGolfCourses',
    USER_CYCLING_PROFILES = 'UserCyclingProfiles',
    USER_ACTIVITY_LOCATIONS = 'UserActivityLocations',
    COMMUNITY_EVENTS = 'CommunityGroupEvents',
    COMMUNITY_NAMES = 'CommunityGroupNames',
    COMMUNITY_VERIFIED_PHONES = 'CommunityVerifiedPhones',
    ACCOUNT = 'Accounts',
    MESSAGES = 'Messages',
    LEADS = 'Leads',
    USER = "_User",
    NOTIFICATIONS = "Notifications",
    ADS = 'Ads',
    TERMS = 'TermsAndConditions',
    PRIVACY = 'Privacypolicy',
    CUSTOMERCONSENT = 'CustomerConsent',
    BUSINESSREVIEWS = 'BusinessReviews'
}
